import { ArchivesHome } from './ArchivesHome';
import { UiFeatureLite } from '@/app/feature';
import { FeatureCodes } from '@ssar-app/domain';

export const archivesFeature: UiFeatureLite = {
  code: FeatureCodes.AscendArchives,
  rootComponent: <ArchivesHome />,
};
